import { Phone } from "lucide-react";
import { COMPANY } from "@/lib/data";
import { useDemoModal } from "@/components/DemoModalContext";
import { Reveal } from "@/components/Reveal";

export default function CTA() {
  const { setOpen } = useDemoModal();
  return (
    <section className="container-shell" data-testid="cta">
      <Reveal>
        <div className="relative overflow-hidden rounded-[32px] bg-ink px-8 py-16 text-center md:px-16 md:py-24">
          <div className="pointer-events-none absolute -right-20 -top-20 h-72 w-72 rounded-full bg-orange/25 blur-3xl" />
          <div className="pointer-events-none absolute -bottom-24 -left-16 h-72 w-72 rounded-full bg-lime/20 blur-3xl" />
          <div className="relative">
            <p className="text-sm font-bold uppercase tracking-[0.22em] text-orange">
              Hazır mısınız?
            </p>
            <h2 className="mx-auto mt-4 max-w-3xl text-3xl font-extrabold leading-tight tracking-tight text-white md:text-5xl">
              İşletmenizi geleceğe taşıyacak çözümü birlikte bulalım.
            </h2>
            <div className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row">
              <button
                onClick={() => setOpen(true)}
                className="btn-primary w-full sm:w-auto"
                data-testid="cta-demo-btn"
              >
                Demo Talebi Oluştur
              </button>
              <a
                href={`tel:${COMPANY.phoneRaw}`}
                className="inline-flex w-full items-center justify-center gap-2 rounded-full border border-white/25 bg-white/5 px-7 py-3.5 font-semibold text-white transition-[transform,background-color] duration-300 hover:-translate-y-0.5 hover:bg-white/15 sm:w-auto"
                data-testid="cta-call-btn"
              >
                <Phone className="h-4 w-4" /> {COMPANY.phone}
              </a>
            </div>
          </div>
        </div>
      </Reveal>
    </section>
  );
}
